import { CommandExecutor } from './command-executor';
import * as TSE from 'ts-events';

export declare interface SelectUserCommandParameters {
    userId: number;
    forceSelect?: boolean;
}

export class SelectUserCommandExecutor extends CommandExecutor {
    public static commandExecutorCreated = new TSE.SyncEvent();
    public previousOptions: SelectUserCommandParameters;

    constructor() {
        super();
        SelectUserCommandExecutor.commandExecutorCreated.post(this);
    }

    public requestExecute = (options: SelectUserCommandParameters) => {
        if (this.previousOptions && this.previousOptions.userId === options.userId && !options.forceSelect) {
            this.notifyExecute({ userId: null });
            this.previousOptions = { userId: null };
        } else {
            this.notifyExecute(options);
            this.previousOptions = options;
        }
    }
}
